export const KEYS = {
  FALLBACK_LANGUAGE: 'en',
};

export default KEYS;
